import {match} from 'ts-pattern';

import {isBoolean, isString} from 'ramda-adjunct';

import {DEFAULT_COL_WIDTH} from '../constants/defaultColWidth';
import type {
  ColumnResponseBody,
  ColumnsSetting,
  GetDataQueryResponse,
  TransformedDefinitionApiResponse,
} from '../types/Api';
import type {EagColumn} from '../types/EagColumn';

type SortEntry = {column: string; order: 'ASC' | 'DESC'};

export const columnToBasicDefs = (
  dataQuery: GetDataQueryResponse,
  definition: TransformedDefinitionApiResponse,
  column: ColumnResponseBody,
  defaultPresetColumn?: ColumnsSetting,
  defaultPresetOrder?: SortEntry,
  defaultPresetOrderIndex?: number
): Partial<EagColumn> => {
  const isNewlyAddedColumnVisible = !definition.behavior.columnToolPanelVisible;

  const sortEntry = dataQuery.order?.find((ord) => ord.columnKey === column.key);
  const sort = sortEntry?.order as 'ASC' | 'DESC' | undefined;

  const pinned = match<ColumnsSetting['pinned'] | undefined, EagColumn['pinned']>(
    defaultPresetColumn?.pinned
  )
    .when(isBoolean, (p) => (p === true ? 'LEFT' : null))
    .when(isString, (p) => (p.toUpperCase() === 'RIGHT' ? 'RIGHT' : 'LEFT') as 'LEFT' | 'RIGHT')
    .otherwise(() => null);

  const isVisible = defaultPresetColumn?.visible ?? isNewlyAddedColumnVisible;

  return {
    key: column.key,
    headerName: column.title,
    field: column.key,
    cellClass: 'ellipsis',
    hidden: !isVisible || column.hidden,
    suppressToolPanel: column.hidden,
    width: defaultPresetColumn?.width ? defaultPresetColumn.width : DEFAULT_COL_WIDTH,
    sortable: column.sortable,
    toolPanelClass: `columnSettings-${column.key}`,
    pinned,
    ...(sort != null ? {sort} : {}),
    ...(defaultPresetOrderIndex != null ? {sortIndex: defaultPresetOrderIndex} : {}),
  };
};
